/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./info-window";
import * as i2 from "../services/managers/info-window-manager";
var styles_AgmInfoWindow = [];
var RenderType_AgmInfoWindow = i0.ɵcrt({ encapsulation: 2, styles: styles_AgmInfoWindow, data: {} });
export { RenderType_AgmInfoWindow as RenderType_AgmInfoWindow };
export function View_AgmInfoWindow_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 3, "div", [["class", "agm-info-window-content"]], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n      "])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(-1, null, ["\n    "])), (_l()(), i0.ɵted(-1, null, ["\n  "]))], null, null); }
export function View_AgmInfoWindow_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "agm-info-window", [], null, null, null, View_AgmInfoWindow_0, RenderType_AgmInfoWindow)), i0.ɵdid(1, 770048, null, 0, i1.AgmInfoWindow, [i2.InfoWindowManager, i0.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AgmInfoWindowNgFactory = i0.ɵccf("agm-info-window", i1.AgmInfoWindow, View_AgmInfoWindow_Host_0, { latitude: "latitude", longitude: "longitude", disableAutoPan: "disableAutoPan", zIndex: "zIndex", maxWidth: "maxWidth", isOpen: "isOpen" }, { infoWindowClose: "infoWindowClose" }, ["*"]);
export { AgmInfoWindowNgFactory as AgmInfoWindowNgFactory };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/@agm/core/directives/info-window.ngfactory.js.pre-build-optimizer.js